import { UserRoleEnum } from '@app/types';

export interface EventCreationRouter {
  goToDetail(id: string, role?: UserRoleEnum): void;
  goToList(query?: string): void;
  goToCreate(search: string): void;
  goToCreateBatch(params: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
    role?: UserRoleEnum;
  }): void;
  goBack(prevState: { pathname: string; search: string }): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventCreationRouter = Symbol('EventCreationRouter');
